import React from 'react';
import { CheckIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';
import { CountdownTimer } from './CountdownTimer';
import { bonusValueRows } from '../data/bonuses';
import { bonusValue, brandName, fullPrice, included, price, volumesValue } from '../data/copy';
export function OfferSection() {
  return <section id="oferta" className="defer-paint w-full scroll-mt-6 bg-zinc-950 py-12 sm:py-16" aria-labelledby="offer-heading" data-id="element-116" data-mp="df6qrz2qsnf6">
      <div className="mx-auto max-w-5xl px-6" data-id="element-117" data-mp="icyhiprni3hs">
        <div className="mx-auto max-w-2xl text-center" data-id="element-118" data-mp="meab16dnb8v9">
          <p className="font-sans text-[11px] font-semibold uppercase tracking-[0.22em] text-yellow-500" data-id="element-119" data-mp="mgwk5ag6pwfl">Il tuo accesso completo oggi</p>
          <h2 id="offer-heading" className="mt-4 font-serif text-[2rem] font-bold leading-[1.1] text-stone-100 sm:text-4xl" data-id="element-120" data-mp="wdj31toyadez">
            {brandName}
          </h2>
          <p className="mt-3 font-sans text-base leading-relaxed text-stone-400" data-id="element-121" data-mp="2t7dtkcu4tdvn">
            Sistema completo: 6 volumi + 70 sessioni + 5 bonus.
          </p>
        </div>

        <div className="mt-9 grid gap-6 lg:grid-cols-[1fr_1.1fr] lg:gap-8" data-id="element-122" data-mp="12p35136g1gnn">
          <div className="space-y-6" data-id="element-123" data-mp="xvqufwylnadw">
            <div className="rounded-3xl border border-zinc-800 bg-zinc-900 p-6 sm:p-7" data-id="element-124" data-mp="xup64qskore8">
              <p className="font-sans text-[11px] font-semibold uppercase tracking-[0.22em] text-stone-400" data-id="element-125" data-mp="sxyssb85k9wi">Quanto vale separatamente</p>
              <ul className="mt-5 divide-y divide-zinc-800" data-id="element-126" data-mp="1lm4dixz7hywc">
                <li className="flex items-baseline justify-between gap-4 py-2.5 font-sans text-[0.85rem] text-stone-200" data-id="element-127" data-mp="1lll6icb3gux3">
                  <span data-id="element-128" data-mp="1glgqene3m27e">6 volumi tecnici (70+ sessioni)</span>
                  <span className="shrink-0 text-stone-400" data-id="element-129" data-mp="1ck4vc2cggort">{volumesValue}</span>
                </li>
                {bonusValueRows.map(row => <li key={row.label} className="flex items-baseline justify-between gap-4 py-2.5 font-sans text-[0.85rem] text-stone-200" data-id="element-130" data-mp="17opnbr14pn3b">
                    <span data-id="element-131" data-mp="3sckn36d8sazu">{row.label}</span>
                    <span className="shrink-0 text-stone-400" data-id="element-132" data-mp="3sbizy3iyby1r">{row.value}</span>
                  </li>)}
              </ul>
              <div className="mt-4 flex items-baseline justify-between gap-4 border-t border-yellow-500/30 pt-4" data-id="element-133" data-mp="3ts6luurcbwgq">
                <span className="font-sans text-[11px] font-semibold uppercase tracking-[0.16em] text-yellow-500" data-id="element-134" data-mp="3ktl431tp0lh0">
                  Valore totale del sistema
                </span>
                <span className="font-serif text-3xl font-bold leading-none text-yellow-500" data-id="element-135" data-mp="3owr96652k6lw">
                  {fullPrice}
                </span>
              </div>
              <p className="mt-4 font-sans text-[0.82rem] leading-relaxed text-stone-400" data-id="element-136" data-mp="3fvt2fg38xkzm">
                I 5 bonus ({bonusValue}) sono inclusi oggi senza costi
                aggiuntivi.
              </p>
            </div>

            <CountdownTimer data-id="element-137" data-mp="3622goiyi7onm" />
          </div>

          <div className="rounded-3xl border border-yellow-500/40 bg-zinc-900 p-6 text-center shadow-2xl shadow-black/60 sm:p-9" data-id="element-138" data-mp="2s4dvtb4fshik">
            <p className="font-sans text-sm text-stone-400" data-id="element-139" data-mp="2x376yww93wfk">
              Valore normale:{' '}
              <span className="line-through" data-id="element-140" data-mp="2digrwk3s822g">{fullPrice}</span>
            </p>
            <p className="mt-2 flex items-start justify-center gap-1 font-serif font-bold leading-none text-stone-100" data-id="element-141" data-mp="28jvsgmwctmf2">
              <span className="mt-3 text-2xl text-yellow-500" data-id="element-142" data-mp="2mk6i5mlxguyn">€</span>
              <span className="text-[5rem] leading-none sm:text-[6rem]" data-id="element-143" data-mp="2igs0ysm968jm">19</span>
            </p>
            <p className="mt-2 font-sans text-xs uppercase tracking-[0.16em] text-stone-400" data-id="element-144" data-mp="2wg17f0knpoae">
              Un solo pagamento · nella tua valuta locale
            </p>

            <p className="mt-6 text-left font-sans text-[11px] font-semibold uppercase tracking-[0.22em] text-yellow-500" data-id="element-145" data-mp="366mdta6knx3v">
              Cosa riceverai
            </p>

            <ul className="mt-3 grid grid-cols-2 gap-x-4 gap-y-2 border-t border-zinc-800 pt-4 text-left sm:gap-x-6" data-id="element-146" data-mp="318b3yzga1mln">
              {included.map(item => <li key={item} className="flex items-start gap-2 font-sans text-[0.8rem] leading-snug text-stone-200 sm:text-[0.86rem]" data-id="element-147" data-mp="3a8hcs8115yeh">
                  <CheckIcon className="mt-0.5 h-3.5 w-3.5 shrink-0 text-yellow-500" strokeWidth={2.6} aria-hidden="true" data-id="element-148" data-mp="18i8uzlsbdg44" />
                  {item}
                </li>)}
            </ul>

            <CtaButton size="large" className="mt-7 w-full" data-id="element-149" data-mp="1i9whd8a0k6yq">
              Accesso completo ora — {price}
            </CtaButton>

            <p className="mt-4 text-center font-sans text-[11px] text-stone-400" data-id="element-150" data-mp="1m9nbnlyr1580">
              Pagamento sicuro · accesso immediato · garanzia di 7 giorni
            </p>
          </div>
        </div>
      </div>
    </section>;
}